/**
 * Checks the page content for headings and adds anchor IDs to them.
 * This allows for linking directly to specific sections of the page.
 * The IDs are generated based on the text of the heading, replacing spaces with hyphens and converting to lowercase.
 * The function is designed to be called after the page content has been loaded.
 * It uses a regular expression to match headings (h1, h2, h3, etc.) and adds an ID attribute to each heading.
 * Duplicate IDs are avoided by appending a number if an ID already exists.
 */
export const addAnchorIdsToHeadings = () => {
    const headings = document.querySelectorAll('h1, h2, h3, h4, h5, h6');
    const existingIds = new Set();

    headings.forEach(heading => {
        const text = heading.textContent.trim();
        const tag = heading.tagName.toLowerCase();
        const baseId = `${tag}-${text.replace(/\s+/g, '-').toLowerCase()}`;

        let id = baseId;
        let count = 1;
        // Check for duplicates
        while (existingIds.has(id)) {
            id = `${baseId}-${count}`;
            count++;
        }

        heading.id = id;
        existingIds.add(id);
    });

};
